import ContratTemplateSelect from '@/generated/controls/contratTemplate/ContratTemplateSelect.vue';
import { defineComponent } from 'vue';

export default defineComponent({
    components: {},
    extends: ContratTemplateSelect
})
